import React from 'react';
import PropTypes from 'prop-types';
import { withModalData } from 'core/hocs';
import { ModalWindow } from 'components/modal-window/modal-window';
import { SetupSms2Fa } from 'components/setup-sms-2fa/setup-sms-2fa';
import { MODAL_IDS } from 'src/constants';

import './setup-sms-2fa-modal.scss';

const SetupSms2faModalUI = () => (
  <ModalWindow
    id={MODAL_IDS.SETUP_SMS_2FA}
    coreProps={{ id: MODAL_IDS.SETUP_SMS_2FA }}
    bodyClassName="py-4 px-2"
    className="setup-sms-2fa-modal"
    fade
  >
    <SetupSms2Fa />
  </ModalWindow>
);

SetupSms2faModalUI.propTypes = {
  currentModal: PropTypes.shape({
    id: PropTypes.string,
    data: PropTypes.any
  }).isRequired,
};

export const SetupSms2faModal = withModalData(SetupSms2faModalUI);
